// Required for Angular 19 standalone components to work properly
// We need this import here despite the warning, as it's essential for component rendering
import '@angular/localize/init';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import "@angular/compiler";

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

